import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import QuizService from "../../../services/KangarooServices/QuizService";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import DeleteModal from "../../../Components/Common/DeleteModal";

const Quiz = () => {
  const [data, setData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const navigate = useNavigate();
  const fetchList = async () => {
    try {
      const response = await QuizService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchList();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await QuizService.delete(selectedDeleteItem.slug);
        fetchList();
        toast.success("Quiz deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Quizs" pageTitle="Course Management" />
        <Row>
          {/* <Col lg={6} className="d-flex  mb-2">
            <InputGroup className="w-auto">
              <Input
                placeholder="Search..."
                value={filters.search}
                onChange={handleFilterChange}
              />
            </InputGroup>
          </Col> */}
          <Col
            md={12}
            xs={12}
            lg={12}
            className="d-flex justify-content-end align-items-end mb-2"
          >
            <Button
              className="btn btn-success"
              onClick={() => navigate("/quiz/create")}
            >
              + Create Quiz
            </Button>
          </Col>
        </Row>
        <Row>
          {data?.map((item, index) => (
            <Col lg={4}>
              <Card>
                <CardBody>
                  <p>{item?.quizName}</p>
                </CardBody>
                <CardFooter>
                  <div className="d-flex justify-content-between align-items-center ">
                    {/* <span
                      className="text-primary small fw-semibold cursor-pointer "
                      onClick={() => navigate(`/pages-list/${item?.slug}`)}
                    >
                      Read More →
                    </span> */}
                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="warning"
                        className="d-flex align-items-center gap-1"
                        onClick={() => navigate(`/quiz/update/${item.slug}`)}
                      >
                        <i className="ri-edit-line"></i>
                      </Button>
                      <Button
                        size="sm"
                        color="danger"
                        className="d-flex align-items-center gap-1"
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="ri-delete-bin-5-line"></i>
                      </Button>
                    </div>
                  </div>
                </CardFooter>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default Quiz;
